export const PROJECTS_GRID_ID = 'projects-grid';
export const PROJECTS_EMPTY_STATE_ID = 'projects-empty-state';
export const INITIAL_VISIBLE_PROJECTS = 6;
